import Cancel from '@mui/icons-material/Cancel';
import SaveIcon from '@mui/icons-material/Save';
import {
  Divider,
  Grid,
  MenuItem,
  SelectChangeEvent,
  Typography,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import {
  createNewAppServicePlan,
  RemoveDuplicateAppserviceplans,
} from '../../../Common/CommonMethods';
import CustomButton, {
  CustomSelect,
} from '../../../Common/Components/Controls/InputControls';
import { Loader } from '../../../Common/Components/Loader';
import {
  CardWrapper,
  FooterContainer,
  FooterWrapper,
  PaperWrapper,
} from '../Common/CommonComponents';
import { customerService } from '../Customer/CustomerService';
import { farmService } from '../ManageFarms/FarmService';
import { StorageAccount } from '../StorageAccount/Model/StorageAccountModel';
import { storageAccountService } from '../StorageAccount/StorageAccountService';
import TenantConstants from './Model/TenantConstants';
import { MoveTenant } from './Model/TenantModels';
import { tenantService } from './TenantService';
import { AppserviceSkuDialog } from '../../Common/Dialog/AppserviceSkuDialog';
import { showToast } from '../../../lib/toast';
import { SqlServer } from '../SqlServer/Model/SqlServerModel';
import { sqlServerService } from '../SqlServer/SqlServerService';
import { AzureSearchService } from '../SearchService/Model/AzureSearchServiceModel';
import { azureSearchServiceService } from '../SearchService/AzureSearchServiceService';
interface Param {
  customerId: string;
}

export default function TenantMove() {
  const params = useParams<Param>();
  const history = useHistory();
  const [moveTenant, setMoveTenant] = useState<MoveTenant>();
  const [FarmId, setFarmId] = useState<string>();
  const [loading, setLoading] = useState(true);
  const [appservicePlan, setAppservicePlan] = useState('');
  const initialStorageAccounts: StorageAccount[] = [];
  const [storageAccounts, setStorageAccounts] = React.useState(
    initialStorageAccounts,
  );
  const initialAzureSearchServices: AzureSearchService[] = [];
  const [azureSearchServices, setAzureSearchServices] = React.useState(
    initialAzureSearchServices,
  );
  const [sqlServers, setSqlServers] = React.useState<SqlServer[]>([]);
  const initialAppservicePlans: string[] = [];
  const [appserviceplans, setAppserviceplans] = React.useState(
    initialAppservicePlans,
  );
  const [storageAccount, setStorageAccount] = React.useState('');
  const [azureSearchService, setAzureSearchService] = React.useState('');
  const [sqlServer, setSqlServer] = React.useState('');

  const [openAppserviceDialogue, setOpenAppserviceDialogue] =
    React.useState(false);
  const [selectedValue, setSelectedValue] = React.useState('Not Selected');

  const addItemToState = (item: string[]) => {
    const newItem = createNewAppServicePlan(
      appserviceplans,
      item,
      Number(FarmId),
    );
    const newItemString = Array.isArray(newItem) ? newItem[0] : newItem;

    const updatedAppServicePlans = RemoveDuplicateAppserviceplans([
      ...appserviceplans,
      newItemString,
    ]);

    setAppserviceplans(updatedAppServicePlans);
    setAppservicePlan(newItemString);
  };

  const handleCloseAppservicePlan = (value: string) => {
    setOpenAppserviceDialogue(false);
    if (value !== 'Not Selected') {
      setSelectedValue(value);
      addItemToState([value]);
    }
  };

  const loadStorageAccounts = async () => {
    try {
      await storageAccountService
        .getstorageAccounts()
        .then((storageAccounts) => {
          setStorageAccounts(
            storageAccounts.Items.filter(
              (sa) => sa.Purpose.toLowerCase() === 'archive',
            ),
          );
        });
    } catch (error) {
      console.log(error);
    }
  };
  const loadAzureSearchServices = async () => {
    try {
      await azureSearchServiceService
        .getAzureSearchServices()
        .then((azureSearchServices) => {
          setAzureSearchServices(azureSearchServices.Items);
        });
    } catch (error) {
      console.log(error);
    }
  };

  const loadSqlServers = async () => {
    try {
      await sqlServerService.getSqlServers().then((sqlServers) => {
        setSqlServers(sqlServers.Items);
      });
    } catch (error) {
      console.log(error);
    }
  };

  const validate = () => {
    if (appservicePlan === '') {
      showToast({
        type: 'info',
        title: TenantConstants.AppserviceEmptyWarn,
      });
      return false;
    } else if (FarmId === '' || FarmId === undefined) {
      showToast({
        title: TenantConstants.TargetFarmIdEmptyWarn,
        type: 'info',
      });
      return false;
    } else if (storageAccount === '' || storageAccount === undefined) {
      showToast({
        title: 'Please select a Storage Account.',
        type: 'info',
      });
      return false;
    } else if (sqlServer === '' || sqlServer === undefined) {
      showToast({
        title: 'Please select a SQL Server.',
        type: 'info',
      });
      return false;
    } else if (azureSearchService === '' || azureSearchService === undefined) {
      showToast({
        title: 'Please select Azure search service.',
        type: 'info',
      });
      return false;
    }
    return true;
  };

  const handleMove = async () => {
    if (validate() && moveTenant !== undefined) {
      const Tenant: MoveTenant = {
        SourceFarmID: moveTenant.SourceFarmID,
        FarmID: Number(FarmId),
        AppservicePlan: appservicePlan,
        TenantId: moveTenant.TenantId,
        StorageAccount: storageAccount,
        AzureSearchService: azureSearchService,
        SqlServerName: sqlServer,
        Farms: [],
      };
      try {
        setLoading(true);
        await tenantService.MoveTenant(params.customerId, Tenant).then(() => {
          showToast({
            type: 'success',
            title: TenantConstants.TenantMoved,
          });
        });
        history.push('/customer');
      } catch (error) {
        showToast({
          title: (error as Error).message,
          type: 'error',
        });
        console.log(error);
      } finally {
        setLoading(false);
      }
    }
  };

  const handleAppserviceplanChange = (event: SelectChangeEvent<string>) => {
    const value = event.target.value;
    setAppservicePlan(value);
  };

  const handleChange = (event: SelectChangeEvent<string>) => {
    const value = (event.target as HTMLInputElement).value;
    setFarmId(value);
    const farmId = Number(value);
    setStorageAccounts(
      storageAccounts.filter(
        (sa) =>
          sa.AzureRegion ===
          moveTenant?.Farms.find((farm) => farm.Id === farmId)?.FarmRegion,
      ),
    );
    setStorageAccount('');
    setAzureSearchServices(
      azureSearchServices.filter(
        (sa) =>
          sa.AzureRegion ===
          moveTenant?.Farms.find((farm) => farm.Id === farmId)?.FarmRegion,
      ),
    );
    setAzureSearchService('');
    loadAppservicePlans(Number(value));
    setAppserviceplans(appserviceplans.filter((ap) => ap.includes(value)));
  };
  const handleClose = () => {
    history.push('/customer');
  };

  const loadAppservicePlans = async (FarmId: number) => {
    try {
      setLoading(true);
      await farmService.getAppservicePlans(FarmId).then((appserviceplans) => {
        setAppserviceplans(appserviceplans);
      });
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const handleClickOpen = () => {
    setOpenAppserviceDialogue(true);
  };

  useEffect(() => {
    const loadRegisterTenant = async () => {
      await customerService.getMoveTenant(params.customerId).then((data) => {
        setMoveTenant(data);
        setLoading(false);
      });
    };
    loadRegisterTenant();
    loadStorageAccounts().catch((err) => console.log(err));
    loadAzureSearchServices().catch((err) => console.log(err));
    loadSqlServers().catch((error) => console.log(error));
  }, [params.customerId]);
  return (
    <div>
      {loading && !moveTenant ? (
        <Loader loading={loading} />
      ) : (
        <PaperWrapper>
          <Typography variant="h5" sx={{ mb: 2 }}>
            Move To Different Farm
          </Typography>
          <Divider sx={{ mb: 3 }} />
          <Grid container spacing={3}>
            <Grid item xs={12} sm={12} md={12} lg={6}>
              <CardWrapper>
                <Typography variant="h6" sx={{ mb: 2, fontWeight: 500 }}>
                  Tenant Informations
                </Typography>
                <Divider sx={{ mb: 3 }} />
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={12} sm={6}>
                    <Typography variant="body1">Tenant Id</Typography>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography variant="body1">{params.customerId}</Typography>
                  </Grid>
                </Grid>
                <Grid container spacing={2} alignItems="center" mt={2}>
                  <Grid item xs={12} sm={6}>
                    <Typography variant="body1">Source Farm ID</Typography>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography variant="body1">
                      {moveTenant?.SourceFarmID}
                    </Typography>
                  </Grid>
                </Grid>
                <Grid container spacing={2} alignItems="center" mt={2}>
                  <Grid item xs={12} sm={6}>
                    <Typography variant="body1">Target Farm</Typography>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <CustomSelect
                      name="FarmId"
                      value={FarmId ? FarmId.toString() : ''}
                      onChange={handleChange}
                    >
                      {moveTenant?.Farms.map((farm) => {
                        return (
                          <MenuItem key={farm.Id} value={farm.Id.toString()}>
                            {farm.DisplayName}
                          </MenuItem>
                        );
                      })}
                    </CustomSelect>
                  </Grid>
                </Grid>
                <Grid container spacing={2} alignItems="center" mt={2}>
                  <Grid item xs={12} sm={6}>
                    <Typography variant="body1">Storage Account</Typography>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <CustomSelect
                      disabled={undefined === FarmId ? true : false}
                      name="StorageAccount"
                      required
                      value={storageAccount}
                      onChange={(e) => setStorageAccount(e.target.value)}
                    >
                      {storageAccounts.map((storageAccount) => {
                        return (
                          <MenuItem
                            key={storageAccount.Name}
                            value={storageAccount.Name}
                          >
                            {storageAccount.Name}
                          </MenuItem>
                        );
                      })}
                    </CustomSelect>
                  </Grid>
                </Grid>
                <Grid container spacing={2} alignItems="center" mt={2}>
                  <Grid item xs={12} sm={6}>
                    <Typography variant="body1">
                      Azure search service
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <CustomSelect
                      disabled={undefined === FarmId ? true : false}
                      name="AzureSearchService"
                      required
                      value={azureSearchService}
                      onChange={(e) => setAzureSearchService(e.target.value)}
                    >
                      {azureSearchServices.map((azureSearchService) => {
                        return (
                          <MenuItem
                            key={azureSearchService.Name}
                            value={azureSearchService.Name}
                          >
                            {azureSearchService.Name}
                          </MenuItem>
                        );
                      })}
                    </CustomSelect>
                  </Grid>
                </Grid>
                <Grid container spacing={2} alignItems="center" mt={2}>
                  <Grid item xs={12} sm={6}>
                    <Typography variant="body1">Sql Server</Typography>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <CustomSelect
                      disabled={undefined === FarmId ? true : false}
                      name="StorageAccount"
                      required
                      value={sqlServer}
                      onChange={(e) => setSqlServer(e.target.value)}
                    >
                      {sqlServers.map((sqlServer) => {
                        return (
                          <MenuItem
                            key={sqlServer.ServerName}
                            value={sqlServer.ServerName}
                          >
                            {sqlServer.ServerName}
                          </MenuItem>
                        );
                      })}
                    </CustomSelect>
                  </Grid>
                </Grid>
                <Grid container spacing={2} alignItems="center" mt={2}>
                  <Grid item xs={12} sm={6}>
                    <Typography variant="body1">
                      Target Appservice Plan
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <CustomSelect
                      disabled={FarmId === undefined ? true : false}
                      name={`Appserviceplan`}
                      value={appservicePlan}
                      onChange={(e) => handleAppserviceplanChange(e)}
                    >
                      <MenuItem
                        value={'Create New Appservice Plan'}
                        onClick={handleClickOpen}
                      >
                        Create New Appservice Plan
                      </MenuItem>
                      {appserviceplans.map((plan) => {
                        return (
                          <MenuItem key={plan} value={plan}>
                            {plan}
                          </MenuItem>
                        );
                      })}
                    </CustomSelect>
                    {openAppserviceDialogue && (
                      <AppserviceSkuDialog
                        onClose={handleCloseAppservicePlan}
                        selectedValue={selectedValue}
                        open={openAppserviceDialogue}
                      />
                    )}
                  </Grid>
                </Grid>
              </CardWrapper>
            </Grid>
          </Grid>
          <FooterWrapper>
            <FooterContainer>
              <Grid item sm="auto">
                <CustomButton
                  onClick={handleMove}
                  startIcon={<SaveIcon />}
                  label="Move"
                />
              </Grid>
              <Grid item sm="auto">
                <CustomButton
                  onClick={handleClose}
                  startIcon={<Cancel />}
                  label="Cancel"
                />
              </Grid>
            </FooterContainer>
          </FooterWrapper>
        </PaperWrapper>
      )}
    </div>
  );
}
